import React from 'react'
import { useIntl } from 'react-intl'
import { AiOutlineLeft, AiOutlineRight } from 'react-icons/ai'
import { useResize } from '../../../hooks'
import { ActionButton, Wrapper } from "./index.styled"

const PanoramaButtonComponent = React.memo(({ position = 8.5, object = {}, left = false, right = false, history = {} }) => {
  const intl = useIntl()
  const isMobile = useResize().isMobile;

  const splitText = (fullText) => {
    let splitedText = fullText.split(" ");
    return splitedText.length <= 1 ? fullText : splitedText.map((text, index) => index === 1 ? text + "<br/>" : text + ' ').join(' ').toString();
    
  }
  if(object?.url !== undefined  && object?.label !== undefined){
    let label = object.label ? intl.formatMessage({ id: object.label}): ''
    label = isMobile && !label.includes('<br') ? splitText(label) : label;
    return(
      <React.Fragment>
        {!isMobile &&
          <ActionButton 
              active={true} 
              left={left}
              className="panorama-button text-uppercase icon-link text din size-16 white uppercase d-flex justify-content-around"
              right={right} 
              position={position} 
              onClick={() => { history.push(object.url) }}
          >
            {left && <AiOutlineLeft className="panorama-arrow" />}
            <p className={`label ${left ? 'text-right pr-3' : 'pl-3'}`} dangerouslySetInnerHTML={{ __html: label }}></p>
            {right && <AiOutlineRight className="panorama-arrow" />}
          </ActionButton>
        }
        {isMobile && 
        <React.Fragment>
          <Wrapper className="mobile">
              <p className={`tooltip-mobile label ${left ? 'tooltip-left' : 'tolltip-right'}`} dangerouslySetInnerHTML={{ __html: label }}></p>
          </Wrapper>
          <ActionButton 
              active={true} 
              className="mobile panorama-button icon-link text din size-16 white uppercase d-flex justify-content-around" 
              left={left} 
              right={right} 
              position={position} 
              onClick={() => { history.push(object.url) }}
          >
            {left && <AiOutlineLeft className="panorama-arrow" />}
            {right && <AiOutlineRight className="panorama-arrow" />}
          </ActionButton>
        </React.Fragment>
        }
      </React.Fragment>
    )
  }
  return null
})

export default React.memo(PanoramaButtonComponent)